// modules/house-and-land/Package.js
import React            from 'react';
import $                from 'jquery';
import BackButton       from '../common/BackButton';
import SiteDownloads    from '../common/SiteDownloads';
import PageLoading      from '../PageLoading';
import PckInclusions    from './elements/PckInclusions';
import { browserHistory } from 'react-router';
import SimilarPackageGrid from '../common/SimilarPackageGrid';
import wNumb from 'wnumb';

let sources = require('../config.json');
let priceFormat = wNumb({
    prefix: '$',
    decimals: 0,
    thousand: ','
});


import { onEnquireClick } from '../common/onEnquireClick';
import getPpsUrl from '../common/ppsUrl';

class Package extends React.Component {
	constructor(props) {
		super(props);

		var d = new Date();
		this.package_url = sources.package + '/' +this.props.params.package + "?ts=" + d.getTime();

		this.state = {
			houseandlandpath : '/house-and-land/',
			data: {
				thispackage: {},
				builder: {},
				lot: {},
				stage: {},
				packages: []
			},
			image: null
		};

		this.receivedPackageData    = this.receivedPackageData.bind(this);
        this.thumbnailClick    		= this.thumbnailClick.bind(this);
	}

	componentDidMount() {


		window.scrollTo(0,0);
		$.ajax({url:this.package_url,dataType:'json'}).done(this.receivedPackageData);
	}

	receivedPackageData(data, status, xhr) {
		if(data.error.error === 1) {
			// if there's no data and an error message exists, re-direct to the house and land page.
			browserHistory.push(this.state.houseandlandpath);
		} else {
			let newState = Object.assign(this.state, {
				data: data,
				image: data.thispackage.render
			});
			this.setState(newState);
            // document.getElementById('reloadScroll').scrollIntoView();
		}
	}

	displayLotFlyer(pdf) {
		if(pdf !== "") {
			return (
				<a className="btn btn__action--rev w-80-wd w-100" href={pdf} target="_blank"><i className="icon icon--download"></i><span>DOWNLOAD LOT FLYER</span></a>
			)
		} else {
			return null;
		}
	}

    thumbnailClick(ev) {
        let x = ev.target;
        let newState = Object.assign(this.state, {
            image: $(x).attr('src')
        });
        this.setState(newState);
	}

	render() {
		if (typeof this.state.data.thispackage.id !== "undefined") {
			let price = priceFormat.to(this.state.data.thispackage.price);
			let comment = "Please provide information regarding House and Land package " + this.state.data.thispackage.name + " by " + this.state.data.builder.name + " on Lot " + this.state.data.lot.name;
			return (
				<div className="App">
					<div id="reloadScroll"></div>
					<section className="section p-t-2">
						<div className="container">
							<div className="section__content tc">
								<h1 className="title f3 f4-md f-headline-lg m-b-0">House & Land Packages</h1>
							</div>
						</div>
					</section>
					<section className="section p-h-1 p-h-3-lg section-bg-white land-filter-section">
						<div className="container">
							<div className="cf top-land-filter-section m-b-3-lg m-b-1">
								<div className="w-100">
									<BackButton link={'/house-and-land'}/>
									<div className="cf"></div>
								</div>

								<div className="db dn-lg">
									<div className="tc brd-top p-a-1 w-100 small-grey-font">
										<h2 className="lot-title">Lot {this.state.data.lot.name}<br/>{this.state.data.thispackage.name}</h2>
									</div>
									<div className="tc p-v-1 m-b-1 w-100  small-grey-font">
										<h2 className="lot-measure">{this.state.data.builder.name}</h2>
									</div>
									<div className="tc  p-v-1 w-100  small-grey-font">
										<h2 className="lot-measure fcolor-og"><span className="small-grey-font">From  </span>{price}</h2>
									</div>
									<div>
										<p className="tc tl-lg p-a-1 w-100 fl m-b-05 m-b-0-wd small-grey-font">
											Frontage<span className="fcolor-og small-grey-font"> {this.state.data.lot.frontage}m</span>
											<br/>
											Land Size<span className="fcolor-og small-grey-font"> {this.state.data.lot.area}m<sup>2</sup></span>
											<br/>
											Depth<span className="fcolor-og small-grey-font"> {this.state.data.lot.depth}m</span>
										</p>
									</div>
									<div className="p-a-1 w-100 tc tl-md">
										<div className="btn__container tc tl-md">
											<a className="btn btn__action js-registrationModal w-80-wd w-100" onClick={(ev) => onEnquireClick(ev, this.state.data.builder.name, this.state.data.thispackage.name, this.state.data.lot.name)}><span className="enquire-lot">Enquire about this package</span></a>
										</div>
									</div>
								</div>

								<div className="w-100 w-70-lg fr-lg p-v-1-md">
									<img src={this.state.image} alt="" width="100%"/>
									<div className="cf m-t-1">
										<div className="w-33 fl tc p-v-1-lg p-v-05 cursor-hover">
											<img className="select-package-image" src={this.state.data.thispackage.render} alt="" onClick={this.thumbnailClick} />
										</div>
										<div className="w-33 fl tc p-v-1-lg p-v-05 cursor-hover">
											<img className="select-package-image" src={this.state.data.thispackage.floorplan} alt="" onClick={this.thumbnailClick} />
										</div>
										<div className="w-33 fl tc p-v-1-lg p-v-05">
											<img className="select-package-image" src={this.state.data.builder.logo} alt={this.state.data.builder.name} />
										</div>
									</div>
								</div>

								<div className="w-100 w-30-lg fr-lg">
									<div className="cf">
										<div className="dn db-lg">
											<div className="tc tl-lg brd-top p-a-1 w-100 small-grey-font">
												<h2 className="lot-title">Lot {this.state.data.lot.name}<br/>{this.state.data.thispackage.name}</h2>
											</div>
											<div className="tc tl-lg p-v-1 m-b-1 w-100  small-grey-font">
												<h2 className="lot-measure">{this.state.data.builder.name}</h2>
											</div>
											<div className="tc tl-lg p-v-1 w-100  small-grey-font">
												<h2 className="lot-measure fcolor-og"><span className="small-grey-font">From  </span>{price}</h2>
											</div>
											<div>
												<p className="tc tl-lg p-a-1 w-100 fl m-b-05 m-b-0-wd small-grey-font">
													Frontage<span className="fcolor-og small-grey-font"> {this.state.data.lot.frontage}m</span>
													&nbsp;&nbsp;
													Land Size<span className="fcolor-og small-grey-font"> {this.state.data.lot.area}m<sup>2</sup></span>
													&nbsp;&nbsp;&nbsp;
													Depth<span className="fcolor-og small-grey-font"> {this.state.data.lot.depth}m</span>
												</p>
											</div>
											<div className="p-a-1 w-100 tc tl-md">
												<div className="btn__container tc tl-md">
													<a className="btn btn__action js-registrationModal w-80-wd w-100" onClick={(ev) => onEnquireClick(ev, this.state.data.builder.name, this.state.data.thispackage.name, this.state.data.lot.name)}><span className="enquire-lot">Enquire about this package</span></a>
												</div>
											</div>
										</div>

										<ul className="p-a-1 brd-top">
											<li className=" no-hov">
												<div className="btn__container tc tl-md">
													<a className="btn btn__action--rev w-80-wd w-100" href={this.state.data.thispackage.pdf + '?package=' + this.state.data.thispackage.id} target="_blank"><i className="icon icon--download"></i><span>DOWNLOAD PACKAGE FLYER</span></a>
												</div>
											</li>
											<li className="p-t-1 no-hov">
												<div className="btn__container tc tl-md">
													{this.displayLotFlyer(this.state.data.lot.pdf)}
												</div>
											</li>
											{getPpsUrl(this.state.data.lot.pps_url) ? (
												<li className="p-t-1 no-hov">
													<div className="btn__container tc tl-md">
														<a className="btn btn__action--rev w-80-wd w-100" href={getPpsUrl(this.state.data.lot.pps_url)} target="_blank" rel="noopener noreferrer"><i className="icon icon--download"></i><span>DOWNLOAD PPS</span></a>
													</div>
												</li>
											) : null}
										</ul>

										<PckInclusions>{this.state.data.thispackage.inclusions}</PckInclusions>
									</div>
								</div>
							</div>
							<SiteDownloads  divClass="cf p-a-1 btm-land-filter-section m-b-3-lg m-b-1"/>
							<SimilarPackageGrid data={this.state.data.s_packages} label={'Similar House & Land Packages:'} />
						</div>
					</section>
				</div>
			);
		} else {
			return (
				<PageLoading>Package information</PageLoading>
			);
		}
	}
}

export default Package;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/Package.js
 **/